import React from 'react';
import {Link} from 'react-router-dom';
import moment from 'moment';

import {db} from '../../firebase';

class PricingDashboard extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      isLoading: true,
      streetTeamPricing: null
    }
  }

  componentDidMount = () => {
    db
    .collection('streetTeamPricing/')
    .onSnapshot((querySnapshot) => {
      console.log(querySnapshot.docs)
      this.setState({
        isLoading: false,
        streetTeamPricing: querySnapshot.docs,
      })
    });
  }

  render() {
    const {streetTeamPricing, isLoading} = this.state;

    if (isLoading) {
      return (
        <div>
          Loading pricing...
        </div>
      )
    }

    return (
      <div className='container-fluid'>
        <div className='row'>
          <div className='col'>
            <h3>Pricing</h3>

            <div className='table-responsive my-2'>
              <table className='table'>
                <thead>
                  <tr>
                    <th>Market</th>
                    <th>Emergency</th>
                    <th>Repair</th>
                    <th>Missing</th>
                    <th>Regular</th>
                    <th>Updated At</th>
                    <th>Updated By User</th>
                  </tr>
                </thead>

                <tbody>
                  {streetTeamPricing.map((doc) => {
                    const {id: market} = doc;
                    const {
                      emergencyBounty, repairBounty, missingBounty, regularBounty, updatedAt,
                      updatedByUserEmail
                    } = doc.data();

                    return (
                      <tr key={market}>
                        <td>
                          <Link to={`/admin/pricing/${market}`}>
                            {market}
                          </Link>
                        </td>
                        <td>{emergencyBounty}</td>
                        <td>{repairBounty}</td>
                        <td>{missingBounty}</td>
                        <td>{regularBounty}</td>
                        <td>{updatedAt && moment(updatedAt.toDate()).fromNow()}</td>
                        <td>{updatedByUserEmail}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

PricingDashboard.propTypes = {

};

export {PricingDashboard};



// WEBPACK FOOTER //
// ./src/street-team/admin/PricingDashboard.js